export const translations = {
  en: {
    nav: {
      portfolio: 'Portfolio',
      switchToDark: 'Switch to dark mode',
      switchToLight: 'Switch to light mode',
      switchToSpanish: 'Switch to Spanish',
      switchToEnglish: 'Switch to English',
      language: 'Language'
    },
    tabs: {
      overview: 'Overview',
      skills: 'Skills',
      portfolio: 'Projects',
      experience: 'Experience',
      contact: 'Contact',
      profileSections: 'Profile sections'
    },
    sidebar: {
      contact: 'Contact',
      resume: 'Resume',
      location: 'Medellín, Colombia'
    },
    skills: {
      title: 'Skills',
      technologies: 'Technologies',
      languages: 'Languages',
      professionalStrengths: 'Professional strengths',
      spanish: 'Spanish',
      english: 'English'
    },
    portfolio: {
      popularRepositories: 'Popular repositories',
      defaultDescription:
        'A production-ready application focused on usability and maintainable architecture.',
      public: 'Public',
      liveDemo: 'Live demo',
      source: 'Source'
    },
    experience: {
      title: 'Experience',
      work: 'Work',
      education: 'Education'
    },
    contact: {
      links: 'Links',
      email: 'Email',
      getInTouch: 'Get in touch',
      description:
        'Open to meaningful collaborations, engineering conversations, and opportunities to build products that make a difference.'
    },
    description: {
      readmePath: 'davidrzuluaga / README.md'
    },
    common: {
      loading: 'Loading profile…',
      loadError: 'Unable to load profile data. Please try again later.',
      footer: '© 2026 David R. Zuluaga'
    }
  },
  es: {
    nav: {
      portfolio: 'Portafolio',
      switchToDark: 'Cambiar a modo oscuro',
      switchToLight: 'Cambiar a modo claro',
      switchToSpanish: 'Cambiar a español',
      switchToEnglish: 'Cambiar a inglés',
      language: 'Idioma'
    },
    tabs: {
      overview: 'Resumen',
      skills: 'Habilidades',
      portfolio: 'Proyectos',
      experience: 'Experiencia',
      contact: 'Contacto',
      profileSections: 'Secciones del perfil'
    },
    sidebar: {
      contact: 'Contacto',
      resume: 'Currículum',
      location: 'Medellín, Colombia'
    },
    skills: {
      title: 'Habilidades',
      technologies: 'Tecnologías',
      languages: 'Idiomas',
      professionalStrengths: 'Fortalezas profesionales',
      spanish: 'Español',
      english: 'Inglés'
    },
    portfolio: {
      popularRepositories: 'Repositorios destacados',
      defaultDescription:
        'Una aplicación lista para producción enfocada en usabilidad y arquitectura mantenible.',
      public: 'Público',
      liveDemo: 'Demo en vivo',
      source: 'Código fuente'
    },
    experience: {
      title: 'Experiencia',
      work: 'Trabajo',
      education: 'Educación'
    },
    contact: {
      links: 'Enlaces',
      email: 'Correo',
      getInTouch: 'Ponte en contacto',
      description:
        'Abierto a colaboraciones significativas, conversaciones de ingeniería y oportunidades para construir productos que marquen la diferencia.'
    },
    description: {
      readmePath: 'davidrzuluaga / README.md'
    },
    common: {
      loading: 'Cargando perfil…',
      loadError:
        'No se pudo cargar la información del perfil. Inténtalo de nuevo más tarde.',
      footer: '© 2026 David R. Zuluaga'
    }
  }
};
